import { gql } from "_graphql-types-frontend/gql";

export const NOTIFICATIONS_QUERY = gql(/* GraphQL */ `
  query Notifications($limit: Int) {
    notifications(limit: $limit) {
      id
      eventType
      subjectType
      subjectId
      message
      detail
      hasArtifact
      reason
      createdAt
      readAt
    }
  }
`);

export const NOTIFICATION_ARTIFACT_URL = gql(/* GraphQL */ `
  query NotificationArtifactUrl($id: Int!) {
    notificationArtifactUrl(id: $id)
  }
`);

export const MARK_NOTIFICATIONS_READ = gql(/* GraphQL */ `
  mutation MarkNotificationsRead($ids: [Int!]!) {
    markNotificationsRead(ids: $ids)
  }
`);

export const MUTED_NOTIFICATION_COUNT = gql(/* GraphQL */ `
  query MutedNotificationCount {
    mutedNotificationCount
  }
`);

export const NOTIFICATION_EVENT_PREFERENCES = gql(/* GraphQL */ `
  query NotificationEventPreferences {
    notificationEventPreferences {
      eventType
      requiresSubscription
      subscribedDirectly
      subscribedViaGroup
      toast
      email
      usingDefaults
    }
  }
`);

